import React from "react";
import { Helmet } from "react-helmet";
import { Button } from "@material-ui/core";
import { WhatsApp } from "@material-ui/icons";
import { TextField, Select, FormControl, InputLabel, MenuItem } from "@material-ui/core";

import Header from "../sections/Header";
import LineSeparator from "../sections/LineSeparator";
import GreenBlockSection from "../sections/GreenBlockSection";
import EventDetails from "../sections/EventDetails";
import eventDetailsData from "./eventDetailsData";

const styles = {
  homeButton: {
    width: "100%",
    maxWidth: "300px",
    height: "50px",
    textTransform: "none",
  },
  input: {
    marginBottom: 15,
    textTransform: "none",
    textAlign: "left",
  },
  submitButton: {
    width: 220,
    backgroundColor: "#fff",
    color: "#6F766B",
    marginTop: 10,
    textTransform: "none",
  },
  buyButton: {
    marginTop: 10,
    width: 220,
  },
};

const TICKETS = {
  // EVENT10: {
  //   name: "Bollywood Night Under the Stars",
  //   label: "Bollywood Night Under the Stars - 1 May 2026",
  //   price: 550,
  // },
  // EVENT11: {
  //   name: "Pause & Petals Mother's Day Event",
  //   label: "Pause & Petals Mother's Day Event - 10 May 2026",
  //   price: 1295,
  // },
  EVENT12: {
    name: "An Enchanted Evening at Shepstone Gardens",
    label: "An Enchanted Evening at Shepstone Gardens - 7 October 2026",
    price: 680,
    hideAfter: new Date("2026-10-08T00:00:00+02:00"),
  },
  EVENT13: {
    name: "Spooky Season Special: The Addams Family",
    label: "Spooky Season Special: The Addams Family - 31 October 2026",
    price: 650,
  },
};

// Events with a hideAfter date drop off the page and the ticket list automatically
const isAvailable = (ticket) => !ticket.hideAfter || new Date() < ticket.hideAfter;

const MarketTickets = () => {
  const availableTickets = Object.values(TICKETS).filter(isAvailable);
  const [type, setType] = React.useState(availableTickets[0]);
  const [quantity, setQuantity] = React.useState(1);
  const [purchaserName, setName] = React.useState("");
  const [purchaserEmail, setEmail] = React.useState("");
  const [purchaserCell, setCell] = React.useState("");

  const [carouselIndex, setCarouselIndex] = React.useState(0);
  const [addamsIndex, setAddamsIndex] = React.useState(0);

  return (
    <div>
      <Helmet>
        <title>2026 Events | The Shepstone Experience</title>
        <meta
          name={"description"}
          content={"Book your tickets for the next event at Shepstone Gardens in Johannesburg. Tickets are limited, so book soon!"}
        ></meta>
      </Helmet> 

      <Header
        bgImg={"/images/tickets-header.jpg"}
        headText={"2026 EVENTS"}
      />

      <LineSeparator noLine />
      <LineSeparator noLine />

      <section className={"market-intro-section"}>
        <GreenBlockSection
          headText={"Join us at our next event!"}
          subHeadText={"The Shepstone Experience"}
        >
          <div className={"three-columns"}>
            <p className={"venue-intro-text"}>
              Join us in 2026 at our themed public events at the beautiful Shepstone Gardens. Each event is completely unique!
            </p>
            <p className={"venue-intro-text"}>
              From quiz nights to photoshoots to picnics: there's an event for everybody to attend! Let the good times roll.
            </p>
            <p className={"venue-intro-text"}>
              Tickets are limited, so please make sure you book online well in advance in order to avoid disappointment. We can't wait to see you!
            </p>
          </div>
        </GreenBlockSection>
        <LineSeparator noLine />
        <LineSeparator noLine />

        {/* EVENTS */}
        <GreenBlockSection
          headText={"Events"}
          subHeadText={"Upcoming"}
        >
          {/* {isAvailable(TICKETS.EVENT12) && (
            <React.Fragment>
              <div
                className={"event-item"}
                id={"enchanted-evening"}
              >
                <div className={"event-item-carousel"}>
                  <img
                    src={"/images/market/enchanted-evening-1-2.jpg"}
                    className={`standard-box ${carouselIndex === 0 ? "active" : ""}`}
                  />
                  <img
                    src={"/images/market/enchanted-evening-2-2.jpg"}
                    className={`standard-box ${carouselIndex === 1 ? "active" : ""}`}
                  />
                  <div className={"event-item-carousel-controls"}>
                    <div
                      className={`carousel-control ${carouselIndex === 0 ? "active" : ""}`}
                      onClick={() => setCarouselIndex(0)}
                    />
                    <div
                      className={`carousel-control ${carouselIndex === 1 ? "active" : ""}`}
                      onClick={() => setCarouselIndex(1)}
                    />
                  </div>
                </div>
                <div className={"event-intro-text"}>
                  <h3>An Enchanted Evening at Shepstone Gardens</h3>
                  <p>
                    Featuring an Immersive Sound Journey with Steve Tsakiris.
                  </p>
                  <p>
                    Step away from the pace of everyday life and immerse yourself in an evening of calm, beauty and deep relaxation.
                  </p>
                  <p>
                    As dusk settles and the sun sets, step into the magical wonderland of Shepstone Gardens, where the evening begins with a gentle guided walk through the gardens and unique spaces of this remarkable venue. Slow down. Breathe deeply. Leave the outside world behind.
                  </p>
                  <p>
                    As darkness falls, you'll be invited into the Ballroom for an immersive Sound Journey guided by Steve Tsakiris.
                  </p>
                  <p>
                    There's nothing to do and nowhere to be. Simply lie back, close your eyes and allow the rich sounds and gentle vibrations of singing bowls, gongs, the handpan and other instruments to carry you into a state of deep rest, where the mind begins to quiet, the body softens and a deep sense of calm emerges.
                  </p>
                  <p>
                    Give yourself the gift of an evening unlike any other. Experience Shepstone Gardens in a way few people ever do; a rare opportunity to slow down, deeply unwind and rediscover the restorative power of deep relaxation.
                  </p>
                  <p>
                    <b>Event Details:</b><br />
                    📍 Shepstone Gardens, 12 Hope Road, Mountain View, Johannesburg<br />
                    🎟️ R680 per person<br />
                    📅 Wednesday, 7 October 2026<br />
                    🕔 5PM – 8PM<br />
                    🪷 An evening of beauty, stillness and sound. No experience necessary.<br />
                    ⚠️ Places are limited to preserve the intimacy of the experience!
                  </p>
                </div>

                <Button
                  href={"/Event-Tickets#ticket-bookings"}
                  variant={"contained"}
                  color={"secondary"}
                  style={styles.buyButton}
                  onClick={() => setType(TICKETS.EVENT12)}
                >
                  Buy Tickets
                </Button>
              </div>

              <LineSeparator noLine />
              <LineSeparator />
              <LineSeparator noLine />
            </React.Fragment>
          )}

          <div
            className={"event-item"}
            id={"addams-family"}
          >
            <div className={"event-item-carousel"}>
              <img
                src={"/images/market/addams-family-1.jpg"}
                className={`standard-box ${addamsIndex === 0 ? "active" : ""}`}
              />
              <img
                src={"/images/market/addams-family-2.jpg"}
                className={`standard-box ${addamsIndex === 1 ? "active" : ""}`}
              />
              <img
                src={"/images/market/addams-family-3.jpg"}
                className={`standard-box ${addamsIndex === 2 ? "active" : ""}`}
              />
              <img
                src={"/images/market/addams-family-4.jpg"}
                className={`standard-box ${addamsIndex === 3 ? "active" : ""}`}
              />
              <div className={"event-item-carousel-controls"}>
                <div
                  className={`carousel-control ${addamsIndex === 0 ? "active" : ""}`}
                  onClick={() => setAddamsIndex(0)}
                />
                <div
                  className={`carousel-control ${addamsIndex === 1 ? "active" : ""}`}
                  onClick={() => setAddamsIndex(1)}
                />
                <div
                  className={`carousel-control ${addamsIndex === 2 ? "active" : ""}`}
                  onClick={() => setAddamsIndex(2)}
                />
                <div
                  className={`carousel-control ${addamsIndex === 3 ? "active" : ""}`}
                  onClick={() => setAddamsIndex(3)}
                />
              </div>
            </div>
            <div className={"event-intro-text"}>
              <h3>Spooky Season Special: The Addams Family</h3>
              <p>
                They're creepy and they're kooky, mysterious and spooky... Celebrate Halloween with a screening of The Addams Family in The Great Hall at Shepstone Gardens!
              </p>
              <p>
                Your ticket includes a wickedly themed movie menu:
              </p>
              <p>
                <b>Poison Candy Apple</b><br />
                A glossy candy apple with a crisp shell and juicy centre — sweet, striking and perfectly sinister for the Addams family.
              </p>
              <p>
                <b>School Lunch</b><br />
                Buttery popcorn served in individual brown paper bags just like the school lunch, for a simple, nostalgic and slightly mysterious movie snack.
              </p>
              <p>
                <b>Wednesday's Worms</b><br />
                A creepy-crawly selection of colourful gummy worms — chewy, sweet and perfectly on theme.
              </p>
              <p>
                <b>Cousin Itt's Curls</b><br />
                A fluffy cloud of orange candy floss inspired by Cousin Itt's wild and wonderfully untamed hair.
              </p>
              <p>
                <b>Cyanide Lemonade</b><br />
                A dramatic black lemonade mocktail served as the final takeaway element of the experience. Tart, refreshing and strikingly dark, guests can collect the drink as they leave.
              </p>
              <p>
                <b>Event Details:</b><br />
                📍 The Great Hall, Shepstone Gardens, 12 Hope Road, Mountain View, Johannesburg<br />
                🎟️ R650 per person<br />
                📅 Saturday, 31 October 2026<br />
                🕕 18:00 for 18:30<br />
                🎬 Movie, themed snacks and a takeaway mocktail<br />
                ⚠️ Limited seats available!
              </p>
            </div>

            <Button
              href={"/Event-Tickets#ticket-bookings"}
              variant={"contained"}
              color={"secondary"}
              style={styles.buyButton}
              onClick={() => setType(TICKETS.EVENT13)}
            >
              Buy Tickets
            </Button>
          </div>

          <LineSeparator noLine />
          <LineSeparator />
          <LineSeparator noLine />

          <div className={"event-item"}>
            <img
              src={"/images/market/SG-Winterfrest-2026.jpg"}
              className={"standard-box"}
            />
            <div className={"event-intro-text"}>
              <h3>Winterfest 2026</h3>
              <p>
                Not just a festival: a winter experience! Gather your friends, explore local makers, discover incredible food, and enjoy live entertainment in an atmosphere designed to be remembered.
              </p>
              <p>
                📅 Date 1: Saturday, 25 July 2026 3 PM - 9 PM<br />
                📅 Date 2: Sunday, 26 July 2026 12 PM - 7 PM<br />
              </p>
            </div>
            
            <Button
              href={"https://www.quicket.co.za/events/383257-winter-fest-shepstone-gardens/#/"}
              target={"_blank"}
              variant={"contained"}
              color={"secondary"}
              style={styles.buyButton}
            >
              Buy Tickets
            </Button>
          </div>

          <LineSeparator noLine />
          <LineSeparator />
          <LineSeparator noLine />

          <div
            className={"event-item"}
            id={"spa-mothers-day"}
          >
            <div className={"event-item-carousel"}>
              <img
                src={"/images/market/Mothers-day-event-1.jpg"}
                className={`standard-box ${carouselIndex === 0 ? "active" : ""}`}
              />
              <img
                src={"/images/market/Mothers-day-event-2.jpg"}
                className={`standard-box ${carouselIndex === 1 ? "active" : ""}`}
              />
              <img
                src={"/images/market/Mothers-day-event-3.jpg"}
                className={`standard-box ${carouselIndex === 2 ? "active" : ""}`}
              />
              <img
                src={"/images/market/Mothers-day-event-4.jpg"}
                className={`standard-box ${carouselIndex === 3 ? "active" : ""}`}
              />
              <div className={"event-item-carousel-controls"}>
                <div
                  className={`carousel-control ${carouselIndex === 0 ? "active" : ""}`}
                  onClick={() => setCarouselIndex(0)}
                />
                <div
                  className={`carousel-control ${carouselIndex === 1 ? "active" : ""}`}
                  onClick={() => setCarouselIndex(1)}
                />
                <div
                  className={`carousel-control ${carouselIndex === 2 ? "active" : ""}`}
                  onClick={() => setCarouselIndex(2)}
                />
                <div
                  className={`carousel-control ${carouselIndex === 3 ? "active" : ""}`}
                  onClick={() => setCarouselIndex(3)}
                />
              </div>
            </div>
            <div className={"event-intro-text"}>
              <h3>Pause & Petals Mother's Day Event</h3>
              <p>
                Make this Mother's Day truly special with our Pause & Petals event at Shepstone Spa! Treat your mom to a delightful day of love, calm and connection.
              </p>
              <p>
                With soothing spa treatments, a serene setting like no other, and a delicious continental breakfast, it's the perfect way to show your appreciation and create lasting memories together.
              </p>
              <p>
                The guide floral bouquet design class will be hosted by the talented Head Florist, Megan Lawrenson. It's a wonderful opportunity to bond with your mom and unleash your creativity.
              </p>
              <p>
                <b>Event Details:</b><br />
                📍 Shepstone Spa<br />
                🎟️ R1295 per person<br />
                📅 Sunday, 10 May 2026<br />
                🕑 Starts at 10am<br />
                ⚠️ Limited spots available!
              </p>
            </div>
            
            <Button
              href={"/Event-Tickets#ticket-bookings"}
              variant={"contained"}
              color={"secondary"}
              style={styles.buyButton}
              onClick={() => setType(TICKETS.EVENT11)}
            >
              Buy Tickets
            </Button>
          </div> */}

          <p className={"event-disclaimer-text"}>
            No upcoming events at the moment, but we're working hard to bring you some unforgettable experiences in the near future! Keep an eye on this space for updates, and feel free to reach out if you have any questions or suggestions for future events. We can't wait to welcome you to Shepstone Gardens soon!
          </p>
        </GreenBlockSection>
      </section>

      {/* <form
        className={"message-form standard-width"}
        id={"ticket-bookings"}
        name={"PayFastPayNowForm"}
        action={"https://www.payfast.co.za/eng/process"}
        method={"post"}
      >
        <h3>Book your ticket!</h3>
        <div className={"message-form-inner"}>
          <TextField
            required
            type={"hidden"}
            name={"cmd"}
            value={"_paynow"}
          />
          <TextField
            required
            type={"hidden"}
            name={"receiver"}
            pattern={"[0-9]"}
            value={"15664450"}
          />
          <TextField
            type={"hidden"}
            name={"return_url"}
            value={"https://www.shepstonegardens.co.za/thank-you"}
          />
          <TextField
            type={"hidden"}
            name={"cancel_url"}
            value={"https://www.shepstonegardens.co.za/Event-Tickets"}
          />
          <TextField
            type={"hidden"}
            name={"notify_url"}
            value={"https://www.shepstonegardens.co.za/api/Contact/NotifyMarket"}
          />
          <TextField
            required
            type={"hidden"}
            name={"amount"}
            value={type.price*quantity}
          />

          <FormControl
            style={styles.input}
            variant={"outlined"}
            fullWidth
          >
            <InputLabel>Ticket</InputLabel>
            <Select
              value={type.label}
              onChange={(e) => {
                const selectedTicket = availableTickets.find((ticket) => ticket.label === e.target.value);
                setType(selectedTicket);
              }}
              MenuProps={{
                disableScrollLock: true,
              }}
              label={"Ticket"}
            >
              {availableTickets.map((ticket) => (
                <MenuItem
                  key={ticket.label}
                  value={ticket.label}
                >
                  {ticket.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <TextField
            style={styles.input}
            variant={"outlined"}
            label={"No. of tickets / people"}
            fullWidth
            value={quantity}
            onChange={(e) => setQuantity(e.target.value)}
            type={"number"}
            name={"custom_quantity"}
            min={"1"}
            required
          />

          <TextField
            style={styles.input}
            variant={"outlined"}
            label={"Your name"}
            fullWidth
            value={purchaserName}
            onChange={(e) => setName(e.target.value)}
            name={"custom_str1"}
            required
          />

          <TextField
            style={styles.input}
            variant={"outlined"}
            label={"Your email"}
            fullWidth
            value={purchaserEmail}
            onChange={(e) => setEmail(e.target.value)}
            type={"email"}
            name={"email_address"}
            required
          />

          <TextField
            style={styles.input}
            variant={"outlined"}
            label={"Your contact number"}
            fullWidth
            value={purchaserCell}
            onChange={(e) => setCell(e.target.value)}
            type={"tel"}
            name={"custom_cell"}
            required
          />

          <TextField
            type={"hidden"}
            name={"item_name"}
            maxLength={"255"}
            value={`${type.name} (Quantity: ${quantity})`}
          />
          <TextField
            type={"hidden"}
            name={"item_description"}
            maxLength={"255"}
            value={`Purchaser details: ${purchaserName}, ${purchaserCell}, ${purchaserEmail}`}
          />

          <Button
            variant={"contained"}
            style={styles.submitButton}
            color={"primary"}
            type={"submit"}
          >
            Continue to payment
          </Button>
        </div>
      </form> */}

      <LineSeparator noLine />
      <p className={"text-404"}>If you'd like to chat with us, feel free to send us a WhatsApp and we'll help you however we can!</p>
      <Button
        href={"https://wa.me/27678170890"}
        target={"_blank"}
        startIcon={<WhatsApp />}
        variant={"contained"}
        color={"secondary"}
        style={styles.contactButton}
      >
        Start chat
      </Button>
      
      <LineSeparator noLine />
    </div>
  );
};

export default MarketTickets;

